import React, { useState } from 'react'
import { observer } from 'mobx-react'
import { useEnvValue } from '@morningtrain/react-helpers'
import Buttons from 'app/React/Planting/Buttons'
import Title from 'app/React/Planting/Title'
import Inputs from 'app/React/Planting/Inputs'
import ConsultingField from 'app/React/Planting/ConsultingField'
import Help from 'app/React/Planting/Help'

function Planting(props){
  const [checked] = useEnvValue('planting.checked',false)

  const fieldsWrapperClasses = function(){
    let classes = ['hedge-plant__content']
    if(checked) classes.push('show')
    return classes
  }

  return (
    <div className="hedge-plant on-single-product">
      <div className="hedge-plant__inner">
        <div className="hedge-plant__topbar">
          <Title/>
          <Buttons/>
        </div>
        <div className={fieldsWrapperClasses().join(' ')}>
          <Help />
          <div className='hedge-plant__content-row'>
            <Inputs/>
            <div className="submit-bar">
              <div className="acceptance">
                <ConsultingField/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default observer(Planting)